import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../constants";
import { Container, Card, Row, Col, Form, Button, InputGroup } from "react-bootstrap"; // , Spinner
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProcessingDialog from './ProcessingDialog';

const Pending_Fees = () => {

  const [selectedYear1, setSelectedYear1] = useState();
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);
  const [selectedSection, setSelectedSection] = useState();
  const [ddlSections, setDdlSections] = useState([]);
  const [selectedStd, setSelectedStd] = useState();
  const [ddlStds, setDdlStds] = useState([]);
  const [selectedDiv, setSelectedDiv] = useState();
  const [ddlDivisions, setDdlDivisions] = useState([]);
  const [generationType, setGenerationType] = useState("G");
  
  const [logData, setLogData] = useState([]);

  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {

    loadDropdowns();

  }, []);

  const loadDropdowns = async () => {
    try {

      const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSections(sec.data);

      const year_result = await axios.get(`${BASE_URL}/api/ddl_open_year`);
      setDdlAcademicYears(year_result.data);

      setSelectedYear1(year_result.data[0].year1);

    } catch (err) {
      console.error(err);
    }

  };

  /// To Populate Standard on change of Section
  useEffect(() => {

    const fetchStandard = async () => {
      try {
        setDdlStds([]);
        setDdlDivisions([]);
        if (selectedSection) {
          const std = await axios.get(`${BASE_URL}/api/ddl_standards`, {params: {p_Section_Id: selectedSection}});
          setDdlStds(std.data);
        }
      } catch (error) {
        console.error("Error fetching Std:", error);
      }
    };

    fetchStandard();

  }, [selectedSection]);

  /// To Populate Division on change of Standard
  useEffect(() => {

    const fetchDivision = async () => {
      try {
        setDdlDivisions([]);
        if (selectedStd) {
          const res = await axios.get(`${BASE_URL}/api/ddl_division`, { params: { p_Std_Id: selectedStd } });
          setDdlDivisions(res.data || []);
        }
      } catch (error) {
        console.error("Error fetching Division:", error);
      }
    };

    fetchDivision();

  }, [selectedStd]);
  
  // Fetch report
  const handleGenerateRoll = async () => {

    if (!selectedYear1 || selectedYear1 === '') {
      toast.error("Please select Academic Year.");
      return;      
    } else if (!selectedSection || selectedSection === '') {
      toast.error("Please select Section.");
      return;
    }

    if (!window.confirm("Generate Roll No ?")) return;

    setIsProcessing(true);

    try {

      setLogData([]);

      const res = await axios.post(`${BASE_URL}/api/generate_roll_no`, {
          p_year1: selectedYear1, 
          p_section_id: selectedSection, 
          p_std_id: selectedStd || 0,
          p_div_id: selectedDiv || 0,
          p_gen_regen: generationType, });

      setIsProcessing(false);

      if (res.data.message === '1') {
        let lv_count = Number(res.data.count) || 0;
        let lv_irn = Number(res.data.irn) || 0;
        if (lv_count > 0) {
          toast.success('Roll Nos. Generated, please check the Log. ' + res.data.count);
          const response = await axios.get(`${BASE_URL}/api/get_roll_no_log`, { params: { p_year1: selectedYear1,  p_irn: lv_irn,  } });
          if (response.data.length > 0) {
            setLogData(response.data);
          }
        } else {
          toast.warning('No Roll No. to generate, please check the input.');
        }
      } else {
        setLogData([]);
        toast.error("Unable to generate Roll No !");
      }

    } catch (err) {
      setIsProcessing(false);
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }

  };

  const handleClear = async () => {

    if (!window.confirm("Clear page ?")) return;

    setLogData([]);
    setSelectedSection('');
    setSelectedStd('');
    setSelectedDiv('');
    setGenerationType('G');

  }

  const handlePreviousLogs = async () => {

    if (!window.confirm("View Previous Logs ?")) return;

    setLogData([]);

    const response = await axios.get(`${BASE_URL}/api/get_roll_no_log`, { params: { p_year1: selectedYear1, p_irn: 0, } });

    if (response.data.length > 0) {
      setLogData(response.data);
    }

  }

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">
        <Row>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}>Academic Year 
              </InputGroup.Text>
              <select className="form-select" name="selectedYear1" value={selectedYear1}
                onChange={(e) => setSelectedYear1(e.target.value)} >
                {/* <option value="">--Select Acadamic Year--</option> */}
                {ddlAcademicYears.map(y => (
                  <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "80px" }}> Section 
              </InputGroup.Text>

              <select className="form-select" name="selectedSection" 
                value={selectedSection} onChange={(e) => setSelectedSection(e.target.value)} >
                <option value="">Select Section</option>
                {ddlSections.map(s => (
                  <option key={s.section_id} value={s.section_id}>{s.section_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}> Standard
              </InputGroup.Text>
              <select className="form-select"
                name="selectedStd" value={selectedStd} onChange={(e) => setSelectedStd(e.target.value)} >
                <option value="">--Select Standard--</option>
                {ddlStds.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>

            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>Division
              </InputGroup.Text>
              <select className="form-select" name="selectedDiv"
                value={selectedDiv} onChange={(e) => setSelectedDiv(e.target.value)} >
                <option value="">-- Select Division --</option>
                {ddlDivisions.map(div => (
                  <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                ))}
              </select>
            </InputGroup>

          </Col>

        </Row>

        <Row className="mt-3">

          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Generation Type
              </InputGroup.Text>

              <div
                className="form-control d-flex align-items-center"
                style={{ gap: "20px", whiteSpace: "nowrap" }}
              >
                <Form.Check
                  inline
                  type="radio"
                  label="Generate"
                  name="generationType"
                  id="generation-auto"
                  value="G"
                  checked={generationType === "G"}
                  onChange={(e) => setGenerationType(e.target.value)}
                />

                <Form.Check
                  inline
                  type="radio"
                  // label="Re-Generate (Delete Existing)"
                  label={
                    <span
                      style={{
                        color: generationType === "R" ? "red" : "inherit",
                        // fontWeight: generationType === "R" ? "bold" : "normal"
                      }}
                    >
                      Re-Generate (Delete Existing)
                    </span>}
                  name="generationType"
                  id="generation-manual"
                  value="R"
                  checked={generationType === "R"}
                  onChange={(e) => setGenerationType(e.target.value)}
                />
              </div>
            </InputGroup>
          </Col>

          <Col md={6} className="d-flex justify-content-end">

            <Button variant="success" className="ms-2" onClick={handleGenerateRoll} >Generate Roll No
            </Button>

            {isProcessing && <ProcessingDialog isOpen={isProcessing} />}

            <Button variant="secondary" className="ms-2" onClick={handleClear}  > Clear
            </Button>

            <Button variant="info" className="ms-2" onClick={handlePreviousLogs}  > Previous Logs
            </Button>

          </Col>

        </Row>

      </Card>

      {/* Report Table */}
      <Card className="p-3">

        {logData.length > 0 ? (
          <div style={{ minHeight: '220px' }} className="table-responsive">

            <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table-rcpt hover-table-rcpt">

              <thead className="table-light">
                <tr>
                  {/* <th style={{ textAlign: 'left', width: '10%' }}>Log Id</th> */}
                  <th style={{ textAlign: 'center', width: '6%' }}>Log Id</th>
                  <th style={{ textAlign: 'left', width: '10%' }}>Generated Date Time</th>
                  <th style={{ textAlign: 'left', width: '8%' }}>Std / Div</th>
                  <th style={{ textAlign: 'left', width: '8%' }}>Generation Type</th>
                  <th style={{ textAlign: 'center', width: '10%' }}>Roll No. Generated</th>
                  <th style={{ textAlign: 'left', width: '25%' }}>Generated By</th>
                  
                </tr>
              </thead>

              <tbody>

                {logData.map((n) => (

                  <tr key={n.irn}>
                    <td style={{ textAlign: 'center' }}> {n.log_id} </td>
                    <td style={{ textAlign: 'left' }}> {n.gen_date_time} </td>
                    <td style={{ textAlign: 'center' }}> {n.std_div} </td>
                    <td style={{ textAlign: 'left' }}> {n.gen_type} </td>
                    <td style={{ textAlign: 'center' }}> {n.rolls_count} </td>
                    <td style={{ textAlign: 'left' }}> {n.gen_by} </td>
                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        ) : (
          <table style={{ maxHeight: '35px', border: "none" }} >
            <tbody>
              <tr>
                <td className="text-center">
                </td>
              </tr>
            </tbody>
          </table>
        )}

      </Card>

    </Container>
  );
};

export default Pending_Fees;
